import getConversationItemsOperation from 'owa-service/lib/operation/getConversationItemsOperation';
import type ItemId from 'owa-service/lib/contract/ItemId';
import type ConversationRequestType from 'owa-service/lib/contract/ConversationRequestType';
import type GetConversationItemsJsonRequest from 'owa-service/lib/contract/GetConversationItemsJsonRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { mailItemShape } from '../utils/getMailItemByItemId';
import type GetConversationItemsResponseMessage from 'owa-service/lib/contract/GetConversationItemsResponseMessage';
import type GetConversationItemsJsonResponse from 'owa-service/lib/contract/GetConversationItemsJsonResponse';
import type ConversationSortOrder from 'owa-service/lib/contract/ConversationSortOrder';
import type ConversationNodeSortOrder from 'owa-service/lib/contract/ConversationNodeSortOrder';
import getUserOptions from 'owa-session-store/lib/selectors/getUserOptions';

export default async function getConversationItems(conversationId: ItemId) {
    const jsonRequestHeader = getJsonRequestHeader();
    jsonRequestHeader.RequestServerVersion = 'V2017_08_18';

    const sortOrder = getConversationSortOrderFromSettings();

    const request: GetConversationItemsJsonRequest = {
        Header: jsonRequestHeader,
        Body: {
            ItemShape: mailItemShape,
            SortOrder: sortOrder ? convertConversationSortOrder(sortOrder) : undefined,
            ReturnDeletedItems: false,
            MaxItemsToReturn: 20,
            ReturnModernConversationItems: false,
            Conversations: [{ ConversationId: conversationId } as ConversationRequestType],
        },
    };

    const response: GetConversationItemsJsonResponse = await getConversationItemsOperation(request);
    const responseMessage: GetConversationItemsResponseMessage | null =
        response?.Body?.ResponseMessages?.Items?.[0] || null;

    if (responseMessage?.ResponseClass != 'Success') {
        throw new Error(responseMessage?.ResponseCode);
    }
    const nodes = responseMessage?.Conversation?.ConversationNodes || null;

    return nodes;
}

function getConversationSortOrderFromSettings(): ConversationSortOrder | undefined {
    const sortOrderFromOptions = getUserOptions()
        ?.ConversationSortOrderReact as ConversationSortOrder;
    if (!!!sortOrderFromOptions) {
        return undefined;
    }

    let conversationSortOrder: ConversationSortOrder;
    if (sortOrderFromOptions !== undefined && typeof sortOrderFromOptions == 'string') {
        // Convert string to enum
        conversationSortOrder = sortOrderFromOptions;
    } else {
        conversationSortOrder = sortOrderFromOptions as ConversationSortOrder;
    }
    return conversationSortOrder;
}

export function convertConversationSortOrder(
    conversationSortOrder: ConversationSortOrder
): ConversationNodeSortOrder {
    // Note: only date order ascending is treated specially, all other values are treated as date order descending (the default).
    return conversationSortOrder == 'ChronologicalNewestOnBottom'
        ? 'DateOrderAscending'
        : 'DateOrderDescending';
}
